
import React, { useCallback, useContext, useEffect, useState } from 'react';
import '../../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function FormIPInterfaces(props) {
  const { handleChangeValues, trunks, queues, endpoints, toggleInput } = props;
   

  return (
    <div name="change-entrance-div" className="is-align-content-center">
      <div className="columns mx-2">
        <div className="column is-2 field mt-2">
          <label className="label">Tipo
            <div className="control">
              <div name="only" className="select is-fullwidth">
                <select className="select" name="only" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value={ false }> Tronco </option>
                  <option value={ true }> DDR </option>
                </select>
                <p name="only-placeholder-data" className='has-text-grey-dark is-size-7'>Haverá mais de um tronco?</p>
                <p name="only-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2 my-2">
          <label className="label">Número tronco
            <div className="control">
              <input className="input" name="mask" type="text" placeholder="1421074100 (4 ou + dig.)" onBlur={(e) => handleChangeValues(e.target)} />
              <p name="mask-placeholder-data" className='has-text-grey-dark is-size-7'>Dígitos recebidos da operadora.</p>
              <p name="mask-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
            </div>
          </label>
        </div>
        <div className="column is-1 field mt-2">
          <label className="label">Tempo
            <div className="control">
              <input className="input" name="firstTime" type="number" placeholder="Mín. 5s" onBlur={(e) => handleChangeValues(e.target)} />
              <p name="firstTime-placeholder-data" className='has-text-grey-dark is-size-7'>Duração toque.</p>
              <p name="firstTime-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos.</p>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Operadora
            <div className="control">
              <div name="trunk" className="select is-fullwidth">
                <select className="select" name="trunk" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  { trunks.map((trunk) => <option key={ trunk } value={ trunk }>{ trunk }</option>) }
                </select>
                <p name="trunk-placeholder-data" className='has-text-grey-dark is-size-7'>Tronco de recepção das chamadas.</p>
                <p name="trunk-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div className="column is-2 field mt-2">
          <label className="label">Direcionar
            <div className="control">
              <div name="redirect-type" className="select is-fullwidth">
                <select className="select" name="redirect-type" onChange={(e) => { 
                  handleChangeValues(e.target)
                  }}
                >
                  <option value="vazio">Selecione</option>
                  <option value="endpoint"> Ramal </option>
                  <option value="queue"> Fila </option>
                  <option value="vazio"> URA </option>
                </select>
                <p name="redirect-type-placeholder-data" className='has-text-grey-dark is-size-7'>Tipo de encaminhamento.</p>
                <p name="redirect-type-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div id="queue" className="column is-2 field mt-2 is-hidden">
          <label className="label">Filas
            <div className="control">
              <div className="select is-fullwidth">
                <select className="select" name="redirect-destination" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  { queues.map((queue) => <option key={ queue } value={ queue }>{ queue }</option>) }
                </select>
                <p name="redirect-destination-placeholder-data" className='has-text-grey-dark is-size-7'>Encaminha chamadas para uma fila.</p>
                <p name="redirect-destination-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div id="endpoint" className="column is-2 field mt-2 is-hidden">
          <label className="label">Ramais
            <div className="control">
              <div className="select is-fullwidth">
                <select id="select-endpoint" className="select is-active" name="redirect-destination" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="" onClick={() => {
                    toggleInput('#select-endpoint')
                    toggleInput('#mask-endpoint')
                  }}>
                    Máscara
                  </option>
                  { endpoints.map((endpoint) => <option key={ endpoint } value={ endpoint }>{ endpoint }</option>) }
                </select>
                <input className="input is-hidden" id="mask-endpoint" name="redirect-destination" type="text" placeholder="14210741XX" onBlur={(e) => handleChangeValues(e.target)} />
                <p name="redirect-destination-placeholder-data" className='has-text-grey-dark is-size-7'>Direciona as chamadas para ramal.</p>
                <p name="redirect-destination-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div id="vazio" className="column is-2 field mt-2">
          <label className="label has-text-white">Vazio
            <div className="control">
              <div className="select is-fullwidth">
                <select className="select" name="redirect-destination" onChange={(e) => handleChangeValues(e.target)} disabled >
                  <option value="">Selecione</option>
                </select>
                {/* <p name="redirect-destination-endpoint-placeholder-data" className='has-text-grey-dark is-size-7'>Direciona as chamadas para ramal.</p> */}
                {/* <p name="redirect-destination-endpoint-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p> */}
              </div>
            </div>
          </label>
        </div>
        <div className="column is-1 field mt-2">
          <label className="label">Transbordo
            <div className="control">
              <div name="overflow" className="select is-fullwidth">
                <select className="select" name="overflow" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  <option value="yes"> Sim </option>
                  <option value="no"> Não </option>
                </select>
                <p name="overflow-placeholder-data" className='has-text-grey-dark is-size-7'>Pós 1° entrada.</p>
                <p name="overflow-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
      </div>
      <div name="columns-overflow" className="columns mx-2 is-mobile is-hidden">
        <div className="column is-2 field mt-2 is-half is-offset-4">
          <label className="label">Redirecionar
            <div className="control">
              <div name="redirect-overflowData-typeOverFlow" className="select is-fullwidth">
                <select className="select" name="redirect-overflowData-typeOverFlow" onChange={(e) => { 
                  handleChangeValues(e.target)
                  }}
                >
                  <option value="">Selecione</option>
                  <option value="endpoint"> Ramal </option>
                  <option value="queue"> Fila </option>
                  {/* <option value="ura"> URA </option> */}
                </select>
                <p name="redirect-overflowData-typeOverFlow-placeholder-data" className='has-text-grey-dark is-size-7'>Tipo de redirecionamento.</p>
                <p name="redirect-overflowData-typeOverFlow-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div id="overflow-queue" className="column is-2 field mt-2 is-hidden">
          <label className="label">Filas
            <div className="control">
              <div className="select is-fullwidth">
                <select className="select" name="redirect-overflowData-destinationOverflow" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  { queues.map((queue) => <option key={ 'overflow' + queue } value={ queue }>{ queue }</option>) }
                </select>
                <p name="redirect-overflowData-destinationOverflow-placeholder-data" className='has-text-grey-dark is-size-7'>Encaminha chamadas para uma fila.</p>
                <p name="redirect-overflowData-destinationOverflow-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
        <div id="overflow-endpoint" className="column is-2 field mt-2 is-hidden">
          <label className="label">Ramais
            <div className="control">
              <div className="select is-fullwidth">
                <select className="select" name="redirect-overflowData-destinationOverflow" onChange={(e) => handleChangeValues(e.target)} >
                  <option value="">Selecione</option>
                  { endpoints.map((endpoint) => <option key={ 'overflow' + endpoint } value={ endpoint }>{ endpoint }</option>) }
                </select>
                <p name="redirect-overflowData-destinationOverflow-placeholder-data" className='has-text-grey-dark is-size-7'>Redireciona as chamadas ramal.</p>
                <p name="redirect-overflowData-destinationOverflow-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
              </div>
            </div>
          </label>
        </div>
      </div>
      <br/>
    </div>
  );
}

export default FormIPInterfaces;
